import React, { Component } from "react";

export default class TireVendors extends Component {
  render() {
    return <div>List of contracted Tire Vendors</div>;
  }
}



// WEBPACK FOOTER //
// ./src/customers/TireVendor/TireVendors.js